<template>
    <v-container fluid>
        <v-card>
            <v-toolbar dense flat color="secondary">
                <v-toolbar-title>Invoice Preview</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small text to="/export-sale-invoices">
                    <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>

            <v-card-text>

                <v-row>
                    <v-col cols="12" md="12">
                        <v-btn text @click="generateInvoice" color="accent">
                            <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate
                            Invoice
                        </v-btn>
                        <v-btn text :to="`/edit-export-invoice/${Invoice.id}`" color="primary">
                            <v-icon left>mdi-pencil</v-icon>Edit Invoice
                        </v-btn>
                    </v-col>
                </v-row>

                <v-divider></v-divider>


                <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" md="4">
                        <v-simple-table dense>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <td>Date:</td>
                                        <td>{{ Invoice && Invoice.CreatedAt | date }}</td>
                                    </tr>
                                    <tr>
                                        <td>Invoice#:</td>
                                        <td>{{ Invoice && Invoice.DocNum }}</td>
                                    </tr>
                                    <tr>
                                        <td>Client:</td>
                                        <td>{{ Invoice.Customer && Invoice.Customer.Name }}</td>
                                    </tr>
                                    <tr>
                                        <td>AWB No:</td>
                                        <td>{{ Invoice.AwbNo }}</td>
                                    </tr>
                                    <tr>
                                        <td>No of Boxes:</td>
                                        <td class="font-weight-bold">{{ Invoice.NoOfBoxes }}</td>
                                    </tr>
                                    <tr>
                                        <td>Total Weight:</td>
                                        <td class="font-weight-bold">{{ Invoice.TotalWeight }} Kg</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>

                    <v-col cols="12" offset-md="4" md="4">
                        <v-simple-table dense>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <td class="font-weight-medium">Total Amount:</td>
                                        <td class="font-weight-bold">{{ Invoice && Invoice.CurrencySymbol }} {{ Invoice && Invoice.DocTotal |
                                            currency }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-medium">Total Amount (Ksh):</td>
                                        <td class="font-weight-bold">Ksh {{ Invoice && Invoice.ConvertedTotal | currency }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-medium">Total Cost:</td>
                                        <td class="font-weight-bold">Ksh {{ Invoice && Invoice.TotalGeneralCost | currency }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-medium">Total Cost Variables:</td>
                                        <td class="font-weight-bold">Ksh {{ totalCostVariables | currency }}</td>
                                    </tr>

                                    <tr class="success lighten-4">
                                        <td class="font-weight-bold">Margin:</td>
                                        <td class="font-weight-bold success--text text--darken-2">
                                            Ksh {{ (Invoice.ConvertedTotal - Invoice.TotalGeneralCost) | currency }}
                                        </td>
                                    </tr>

                                    <tr class="success lighten-4">
                                        <td class="font-weight-bold">Margin %:</td>
                                        <td class="font-weight-bold success--text text--darken-2">
                                            {{ marginPercentage }}%
                                        </td>
                                    </tr>

                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>


                <v-row dense id="po" class="text--primary subtitle-2 mt-6">
                    <v-col cols="12">
                        <v-data-table dense light :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers"
                            :items="SaleRows" item-key="id" hide-default-footer>
                            <template v-slot:item.Name="{ item }">
                                <span style="width: 200px">{{ item.product && item.product.Name }}</span>
                            </template>

                            <template v-slot:item.Quantity="{ item }">
                                {{ item.Quantity }}
                            </template>

                            <template v-slot:item.TotalWeight="{ item }">
                                {{ item.TotalWeight }}
                            </template>

                            <template v-slot:item.Price="{ item }">
                                <span v-if="item.Price">{{ item.Price | currency }}</span>
                            </template>

                            <template v-slot:item.LineTotal="{ item }">
                                {{ item.LineTotal | currency }}
                            </template>

                            <template v-slot:body.append>
                                <tr class="font-weight-bold grey lighten-3">
                                    <td></td>
                                    <td class="font-weight-bold">Totals</td>
                                    <td class="font-weight-bold">{{ totalBoxes }}</td>
                                    <td></td>
                                    <td class="font-weight-bold">{{ totalWeight }}</td>
                                    <td></td>
                                    <td class="font-weight-bold">{{ totalLineAmount | currency }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                <!-- snackbar -->
                <snackbar ref="snackbar"></snackbar>
            </v-card-text>
        </v-card>


        <v-row class="mt-4">
            <v-col cols="12" md="6">
                <v-card style="height: 100%">
                    <v-card-text>
                        <span style="font-size: 16px; font-weight: bold">Cost Variables</span>
                        <v-data-table dense light :mobile-breakpoint="0" :items-per-page="pageItems"
                            :headers="costHeaders" :items="SaleCosts" item-key="id" hide-default-footer class="mt-2">

                            <template v-slot:item.Price="{ item }">
                                <span v-if="item.Price">{{ item.Price | currency }}</span>
                            </template>

                            <template v-slot:body.append v-if="SaleCosts.length > 0">
                                <tr class="font-weight-bold grey lighten-3">
                                    <td class="font-weight-bold">Total</td>
                                    <td class="font-weight-bold">{{ totalCostVariables | currency }}</td>
                                </tr>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="6">
                <v-card style="height: 100%">
                    <v-card-text>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <td class="font-weight-medium">Total Freight Cost:</td>
                                        <td class="font-weight-bold">{{ Invoice.TotalFreightCost | currency }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-medium">Advance Payment:</td>
                                        <td class="font-weight-bold">{{ Invoice.AdvancePayment | currency }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>


        <!-- pdf preview -->
        <pdf-preview ref="pdfPreview"></pdf-preview>
        <!-- end -->
    </v-container>
</template>


<script>
import { http, host } from "@/common/index";
export default {
    data: () => ({
        record: {},
        receiptHeaders: [],
        receiptFooters: [],
        showPrinterDiv: false,
        loader: false,
        pageItems: 100,
        Invoice: {},
        TotalPaid: 0,
        Balance: 0,
        OutsourcedProducts: [],
        SaleRows: [],
        SaleCosts: [],
        Payments: [],
        headers: [
            { text: "Hs Code", value: "itemCode" },
            { text: "Product", value: "Name" },
            { text: "Qty (Boxes)", value: "Quantity" },
            { text: "Unit", value: "UOM.UomName" },
            { text: "Total Weight", value: "TotalWeight" },
            { text: "Price", value: "Price" },
            { text: "Total", value: "LineTotal" }
        ],
        outHeaders: [
            { text: "Product", value: "Name" },
            { text: "Qty", value: "Quantity" },
            { text: "Unit", value: "Unit" },
            { text: "Price", value: "Price" },
            { text: "Discount", value: "discount" },
            { text: "Total", value: "LineTotal" }
        ],
        costHeaders: [
            { text: "Item Name", value: "costVariable.Name" },
            { text: "Amount", value: "Price" }
        ],
    }),
    computed: {
        storeName() {
            return localStorage.getItem("storeName");
        },
        marginPercentage() {
            if (!this.Invoice || !this.Invoice.ConvertedTotal || this.Invoice.ConvertedTotal === 0) {
                return '0.00';
            }
            const margin = this.Invoice.ConvertedTotal - this.Invoice.TotalGeneralCost;
            const percentage = (margin / this.Invoice.ConvertedTotal) * 100;
            return percentage.toFixed(2);
        },
        totalCostVariables() {
            if (!this.SaleCosts || this.SaleCosts.length === 0) return 0;
            return this.SaleCosts.reduce((sum, item) => {
                return sum + parseFloat(item.Price || 0);
            }, 0);
        },
        totalBoxes() {
            if (!this.SaleRows || this.SaleRows.length === 0) return 0;
            return this.SaleRows.reduce((sum, item) => {
                return sum + parseFloat(item.Quantity || 0);
            }, 0);
        },
        totalWeight() {
            if (!this.SaleRows || this.SaleRows.length === 0) return 0;
            return this.SaleRows.reduce((sum, item) => {
                return sum + parseFloat(item.TotalWeight || 0);
            }, 0).toFixed(2);
        },
        totalLineAmount() {
            if (!this.SaleRows || this.SaleRows.length === 0) return 0;
            return this.SaleRows.reduce((sum, item) => {
                return sum + parseFloat(item.LineTotal || 0);
            }, 0);
        },
    },
    watch: {
        "$route.params.id": {
            handler: "getById",
            immediate: true,
        },
    },
    methods: {
        getById(val) {
            const self = this;
            // get record
            this.$store
                .dispatch("get", `/export-sales-invoice/${val}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        var invoice = res.ResponseData;
                        self.Invoice = invoice.Invoice;
                        self.TotalPaid = invoice.TotalPaid;
                        self.Balance = invoice.Balance;
                        self.SaleRows = invoice.SaleRows;
                        self.SaleCosts = invoice.SaleCosts;
                        self.OutsourcedProducts = invoice.OutsourcedProducts;
                        self.Payments = invoice.Payments;
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        print() {
            // Get the HTML content you want to print
            const content = document.getElementById("print").innerHTML;

            // Open a new print window
            const printWindow = window.open(
                "",
                "",
                "left=0,top=0,width=100,height=auto,toolbar=0,scrollbars=0,status=0"
            );

            // Write the HTML to the print window, including the content
            printWindow.document.write(`
            <html>
            <head>
                <title>Print</title>
                <style>
                body {
                    width: 80mm;
                    margin: 0 auto;
                }
                @page {
                    size: auto;  /* auto is the current printer page size */
                    margin: 0mm; /* this affects the margin in the printer settings */
                }
                </style>
            </head>
            <body onload="window.print(); window.close();">${content}</body>
            </html>
        `);

            printWindow.document.close();
        },
        generateInvoice() {
            // var isDistributor = localStorage.getItem("IsDistributor");
            var url = "";
            url = "/print-supermarket-invoice-document/14/" + this.Invoice.id;

            const apiUrl = `${host}${url}`;
            const self = this;
            http.get(apiUrl, { responseType: "blob" }).then(response => {
                const blob = new Blob([response.data], { type: "application/pdf" });
                var fileUrl = URL.createObjectURL(blob);
                console.log(' invoice file url', fileUrl);
                self.$refs.pdfPreview.show(fileUrl);
            });
        },
        generateProformaInvoice() {
            var isDistributor = localStorage.getItem("IsDistributor");
            var url = "";
            if (isDistributor == "N") {
                url = "/print-sale-invoice-document/10/" + this.Invoice.id;
            }

            if (isDistributor == "Y") {
                url = "/print-supermarket-invoice-document/14/" + this.Invoice.id;
            }

            const apiUrl = `${host}${url}`;
            const self = this;
            http.get(apiUrl, { responseType: "blob" }).then(response => {
                const blob = new Blob([response.data], { type: "application/pdf" });
                var fileUrl = URL.createObjectURL(blob);
                console.log(' invoice file url', fileUrl);
                self.$refs.pdfPreview.show(fileUrl);
            });
        },
        generateDelivery() {
            var isDistributor = localStorage.getItem("IsDistributor");
            var url = "";
            if (isDistributor == "N") {
                url = "/print-sale-delivery-document/10/" + this.Invoice.id;
            }

            if (isDistributor == "Y") {
                url = "/print-supermarket-delivery-document/10/" + this.Invoice.id;
            }

            const apiUrl = `${host}${url}`;
            const self = this;
            http.get(apiUrl, { responseType: "blob" }).then(response => {
                const blob = new Blob([response.data], { type: "application/pdf" });
                var fileUrl = URL.createObjectURL(blob);
                self.$refs.pdfPreview.show(fileUrl);
            });
        },
        setDate(date) {
            this.record.DocDate = date;
        },
        getReceiptHeaders() {
            this.$store.commit("btnLoader", false);
            const self = this;
            this.$store
                .dispatch("get", `/get-receipt-headers`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.receiptHeaders = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getReceiptFooters() {
            this.$store.commit("btnLoader", false);
            const self = this;
            this.$store
                .dispatch("get", `/get-receipt-footers`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.receiptFooters = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        // updates
        checkExpiry() {
            const self = this;
            const userId = this.subscriberId;
            this.$store
                .dispatch("get", `/users/${userId}`)
                .then((res) => {
                    console.log(res.ResponseData, "res g");
                    if (res.ResponseData.expiryStatus == 1) {
                        self.$router.push("/inactive-account");
                    }
                })
                .catch(() => { });
        },
    },
    created() {
        this.checkExpiry();
        this.getReceiptHeaders();
        this.getReceiptFooters();
    }
};
</script>

<style scoped>
/* .v-text-field__details {
    display: none !important;
  } */
</style>
